import moment from 'moment'
import type { Moment } from 'moment'
export const isSuspended = (
  suspensionDate: Moment,
  suspendedFrom: Moment,
  suspendedTo: Moment,
): boolean => {
  const today = moment().toDate()

  if (suspensionDate != null) {
    const adjustedSuspensionDate = moment(suspensionDate).toDate()
    suspensionDate = moment(
      new Date(
        adjustedSuspensionDate.getFullYear(),
        adjustedSuspensionDate.getMonth(),
        adjustedSuspensionDate.getDate(),
        0,
        0,
        0,
      ),
    )
    if (suspendedFrom == null && suspendedTo == null) {
      return moment(suspensionDate) <= moment(today)
    }

    if (suspendedFrom != null) {
      if (moment(suspendedFrom) > moment(today)) {
        return false
      }
    }

    if (suspendedTo != null) {
      if (moment(suspendedTo) < moment(today)) {
        return false
      }
    }

    return true
  }

  return false
}

export const determineSubscriptionDate = (
  monthlySubscription: boolean,
  paid: boolean,
  paymentDays: number,
  inputSubscriptionExpirationDate: Moment,
  monthlySubscriptionDateOverride: boolean,
) => {
  const endOfMonth = paid
    ? moment().endOf('month').toDate()
    : moment(
        new Date(
          moment().toDate().getFullYear(),
          moment().toDate().getMonth(),
          paymentDays + 1,
          23,
          59,
          59,
        ),
      ).toDate()

  const subscriptionExpirationDate = monthlySubscription
    ? moment(
        new Date(
          endOfMonth.getFullYear(),
          endOfMonth.getMonth(),
          endOfMonth.getDate(),
          23,
          59,
          59,
        ),
      ).toDate()
    : inputSubscriptionExpirationDate != null
      ? moment(inputSubscriptionExpirationDate).toDate()
      : null

  return subscriptionExpirationDate
}
